import React from 'react';
import { NavigationBar, Sidebar } from './index';
import { useSidebar } from '../../contexts/SidebarContext';

interface LayoutProps {
  children: React.ReactNode;
  currentScreen: string;
}

const Layout: React.FC<LayoutProps> = ({ children, currentScreen }) => {
  const { isOpen: sidebarOpen, isMobile } = useSidebar();

  return (
    <div className="h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300 flex overflow-hidden">
      {/* Sidebar */}
      <Sidebar 
        currentScreen={currentScreen} 
        isOpen={sidebarOpen}
      />
      
      {/* Main Content */}
      <div className={`flex-1 flex flex-col min-w-0 min-h-0 ${isMobile && sidebarOpen ? 'lg:ml-0' : ''}`}>
        <NavigationBar 
          currentScreen={currentScreen} 
        />
        
        <main className="flex-1 min-h-0 px-4 sm:px-6 lg:px-8 py-2 sm:py-4 bg-gray-50 dark:bg-gray-900 transition-colors duration-300 overflow-hidden">
          {children}
        </main>
      </div>
    </div>
  );
};

export default Layout;
